// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton__container___QV7wp","text":"Skeleton__text___E6-B8"};